module.exports = __webpack_public_path__ + "img/logo.92107e0f.png";